import { useSelector } from 'react-redux';

import {
  getKnmDataErknmApproveAppeal,
  getKnmDataErknmApproveApproved,
  getKnmDataErknmApproveRemarks,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejectAppealed,
  getKnmIsErknmStatusRejected,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsErknmStatusTypeCompleted,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsNew,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import {
  getIsPlanErknmStatusConsidered,
  getIsPlanErknmStatusUnderConsideration,
} from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { ApprovedTypesEnum } from '../../../APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const useIsPlacesEnabled = () => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isNewKnm = useSelector(getKnmIsNew);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isKnmStatusTypeWaitingCarryOut = useSelector(getKnmIsErknmStatusTypeWaitingCarryOut);
  const isKnmStatusTypeCarriedOut = useSelector(getKnmIsErknmStatusTypeCarriedOut);
  const isKnmStatusTypeCompleted = useSelector(getKnmIsErknmStatusTypeCompleted);
  const isKnmStatusRejected = useSelector(getKnmIsErknmStatusRejected);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isKnmStatusRejectAppealed = useSelector(getKnmIsErknmStatusRejectAppealed);
  const isAvailableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const knmDataApproved = useSelector(getKnmDataErknmApproveApproved);
  const isApproveAppeal = useSelector(getKnmDataErknmApproveAppeal);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isKnmPlanStatusUnderConsidered = getIsPlanErknmStatusUnderConsideration(knmPlanStatus);
  const remarks = useSelector(getKnmDataErknmApproveRemarks);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.PLACES);

  const isActiveFieldPlanConsideredWithApprovedAppeal =
    knmDataApproved === ApprovedTypesEnum.APPROVED && !!isApproveAppeal && isKnmPlanStatusConsidered;

  const isEnabled =
    isSupervisor &&
    (isNewKnm ||
      isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isActiveFieldPlanConsideredWithApprovedAppeal ||
      isKnmStatusTypeWaitingCarryOut ||
      isAvailableInStatusCommentsExist ||
      isKnmStatusTypeCarriedOut ||
      isKnmStatusTypeCompleted ||
      (isKnmPlanStatusUnderConsidered &&
        (isKnmStatusTypeWaitingCarryOut || isKnmStatusRejected || (isKnmStatusCommentsExist && !remarks?.length))) ||
      (isKnmPlanStatusConsidered && ((isKnmStatusCommentsExist && !remarks?.length) || isKnmStatusRejectAppealed)) ||
      (isKnmStatusCommentsExist && isRemarksExists));

  return !isCommonWatchOnly && isEnabled;
};
